import React from 'react';
import { Link } from '../UI';
import './FormLinks.css';
/**
 * Renders form component with links
 *
 * @param  {string} [className] - the CSS classes
 * @param {string} [path] - the name of route path
 * @param  {(to: string) => void} [onLinkHandler] - links onClick handler
 * @param  {string} [linkStyles] - link CSS classes
 *
 * @example
 * <FormLinks onLinkHandler={() => void} path='sign-in' className='a6y-react-auth-form' />
 */
var FormLinks = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'a6y-react-auth__form' : _b, path = _a.path, onLinkHandler = _a.onLinkHandler, _c = _a.linkStyles, linkStyles = _c === void 0 ? '' : _c, _d = _a.displayLinks, displayLinks = _d === void 0 ? '' : _d, _e = _a.beforeLinkText1, beforeLinkText1 = _e === void 0 ? '' : _e, _f = _a.beforeLinkText2, beforeLinkText2 = _f === void 0 ? '' : _f;
    function renderLinks() {
        var ForgotPassword = (React.createElement(Link, { onClick: onLinkHandler, className: linkStyles, to: 'forgot-password' }, "Forgot Password"));
        var SignIn = (React.createElement(Link, { onClick: onLinkHandler, className: linkStyles, to: 'sign-in' }, "Sign In"));
        var SignUp = (React.createElement(Link, { onClick: onLinkHandler, className: linkStyles, to: 'sign-up' }, "Sign Up"));
        switch (path) {
            case 'sign-in':
                return (React.createElement(React.Fragment, null,
                    (displayLinks === 'forgot-password' || displayLinks === 'both') &&
                        beforeLinkText1 &&
                        beforeLinkText1,
                    (displayLinks === 'forgot-password' || displayLinks === 'both') &&
                        ForgotPassword,
                    (displayLinks === 'sign-up' || displayLinks === 'both') &&
                        beforeLinkText2 &&
                        beforeLinkText2,
                    (displayLinks === 'sign-up' || displayLinks === 'both') && SignUp));
            case 'sign-up':
                return (React.createElement(React.Fragment, null,
                    (displayLinks === 'forgot-password' || displayLinks === 'both') &&
                        beforeLinkText1 &&
                        beforeLinkText1,
                    (displayLinks === 'forgot-password' || displayLinks === 'both') &&
                        ForgotPassword,
                    (displayLinks === 'sign-in' || displayLinks === 'both') &&
                        beforeLinkText2 &&
                        beforeLinkText2,
                    (displayLinks === 'sign-in' || displayLinks === 'both') && SignIn));
            default:
                return (React.createElement(React.Fragment, null,
                    (displayLinks === 'sign-up' || displayLinks === 'both') &&
                        beforeLinkText1 &&
                        beforeLinkText1,
                    (displayLinks === 'sign-up' || displayLinks === 'both') && SignUp,
                    (displayLinks === 'sign-in' || displayLinks === 'both') &&
                        beforeLinkText2 &&
                        beforeLinkText2,
                    (displayLinks === 'sign-in' || displayLinks === 'both') && SignIn));
        }
    }
    return React.createElement("div", { className: className }, renderLinks());
};
export default FormLinks;
//# sourceMappingURL=FormLinks.js.map